import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { registerQuery, useQuery } from 'data-fetching-client';
import quickFetch from 'quick-fetch';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { api } from '../utils/api';
import { PORTAL_DATA_PATH, PREVIEW_PORTAL_DATA_PATH } from '../../api/paths';
import { getIsPreview } from '../utils/isPreview';
import { PORTAL_DATA_EARLY_KEY } from '../constants/earlyRequestKeys';
const GET_PORTAL_DATA_KEY = 'getPortalData';
export const getPortalData = async () => {
  const {
    isPreview
  } = getIsPreview();
  const path = isPreview ? PREVIEW_PORTAL_DATA_PATH : PORTAL_DATA_PATH;
  const response = await api(path);
  return response.json();
};
export const fetchPortalDataWithEarlyRequest = (clearEarlyRequest = true) => {
  const {
    isPreview
  } = getIsPreview();
  if (!isPreview) {
    const earlyRequest = quickFetch.getRequestStateByName(PORTAL_DATA_EARLY_KEY);
    if (earlyRequest) {
      return new Promise((resolve, reject) => {
        earlyRequest.whenFinished(data => {
          if (clearEarlyRequest) quickFetch.removeEarlyRequest(PORTAL_DATA_EARLY_KEY);
          resolve(data);
        });
        earlyRequest.onError(() => {
          quickFetch.removeEarlyRequest(PORTAL_DATA_EARLY_KEY);
          getPortalData().then(resolve).catch(reject);
        });
      });
    }
  }
  return getPortalData();
};
const GET_PORTAL_DATA = registerQuery({
  fieldName: GET_PORTAL_DATA_KEY,
  fetcher: () => fetchPortalDataWithEarlyRequest()
});
export const usePortalData = () => {
  const _useQuery = useQuery(GET_PORTAL_DATA),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data[GET_PORTAL_DATA_KEY],
    refetch,
    loading
  }, rest);
};
export const useConfiguredTicketListProperties = () => {
  const {
    data
  } = usePortalData();
  return data === null || data === void 0 ? void 0 : data.configuredTicketListProperties;
};
export const useConfiguredTicketDetailProperties = () => {
  const {
    data
  } = usePortalData();
  return data === null || data === void 0 ? void 0 : data.configuredTicketDetailProperties;
};